import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IAggregateBusinessRepository } from '@/coreInfrastructureModule/interfaces/IAggregateBusinessRepository';
import { StdIndexInfo } from '@/coreDomainsModule/entities/inventory';
import { PutStdInventoryIndicesAdapter } from '../adapters/putStdInventoryIndicesAdapter';

/**
 * 標準在庫指数を更新するユースケース
 */
export class PutStdInventoryIndicesUseCase {
  private repository: IAggregateBusinessRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IAggregateBusinessRepository) {
    this.repository = repository;
  }

  /**
   * 標準在庫指数を更新する
   * @param aggregateBusinessId - 集計ID
   * @param stdInventoryIndicesInfo - 標準在庫指数情報
   */
  public async Execute(aggregateBusinessId: string, stdInventoryIndicesInfo: StdIndexInfo): Promise<INetworkResult<void, Error>> {
    const request = PutStdInventoryIndicesAdapter.adapt(stdInventoryIndicesInfo);
    try {
      const result = await this.repository.putStdInventoryIndices(aggregateBusinessId, request);
      switch (result.status.type) {
        case 'success':
          return {
            status: {
              type: 'success',
              data: undefined,
            },
          };
        case 'error':
          throw result.status.error;
        default:
          throw Error('想定外のエラー');
      }
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('想定外のエラー'),
        },
      };
    }
  }
}
